module.exports = __webpack_public_path__ + "img/protection.bc775ee3.svg";